import { refundDetail, refundSuperiorDetail } from '@/api/refund';
import { IRefundDetailResponse } from '@/types/refund';
import { AxiosError } from 'axios';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useAppSelector } from './useReduxHooks';

export const useRefundDetailForDiscount = () => {
  const [size, setSize] = useState(500);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [enabled, setEnabled] = useState(false);
  const { hospitals, medicalName } = useAppSelector((state) => state.user);
  const { filter } = useAppSelector((state) => state.refund);

  // startDate는 무조건 2026-01-01 이후여야 함
  const minDate = new Date('2026-01-01');
  const actualStartDate =
    filter.startDate < minDate ? minDate : filter.startDate;

  const params = {
    page: pageNumber,
    size,
    productType: filter.productType.name,
    subHospitalId: filter.hospitals.hospitalId,
    startDate: format(actualStartDate, 'yyyy-MM-dd'),
    endDate: format(filter.endDate, 'yyyy-MM-dd'),
    keyword: filter.keyword,
    orderBy: filter.orderBy,
    refundHistoryFilter: filter.orderByRefundStatus,
  };

  const excelQueryString = {
    productType: filter.productType.name,
    startDate: format(actualStartDate, 'yyyy-MM-dd'),
    endDate: format(filter.endDate, 'yyyy-MM-dd'),
  };

  useEffect(() => {
    setEnabled(true);
    return () => setEnabled(false);
  }, [filter]);

  const { data, refetch, isLoading } = useQuery<
    IRefundDetailResponse,
    AxiosError
  >(
    ['refundDetail', params, filter],
    () =>
      hospitals.length > 0
        ? refundSuperiorDetail(params)
        : refundDetail(params),
    {
      onSuccess: (res) => {
        setTotalPage(res.totalPages);
      },
      retry: false,
      enabled,
      keepPreviousData: true,
    },
  );

  return {
    data,
    totalPage,
    refetch,
    pageNumber,
    setPageNumber,
    setSize,
    isLoading,
  };
};
